module.exports = __webpack_public_path__ + "static/img/mv-test-pc20230407.17b3d19.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mv-test-pc20230407.png
// module id = Gatj
// module chunks = 0